import { SET_DEALER_NAME } from '../actions/types';

const setDealerName = (state = '', action) => {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_DEALER_NAME:
				return action.payload;

			// no default
		}
	}

	return state;
};

export default setDealerName;
